export const content = [
  {
    id: 1,
    title: 'Заполните анкету',
    description:
      'Это займёт пару минут, мы сможем узнать все нюансы вашей ситуации, чтобы подобрать для вас подходящих риелторов.',
  },
  {
    id: 2,
    title: 'Поговорите с риелторами',
    description: 'С вами свяжется не более 3-х специалистов, с которыми вы можете обсудить условия работы.',
  },
  {
    id: 3,
    title: 'Выберите специалиста',
    description:
      'Начните работать с понравившимся риелтором или заполните заявку снова, и мы постараемся подобрать кого-то ещё.',
  },
];
